<template>
  <div>
    <!-- Online dot also shows for "en application" (the announce stays
         online while an application is in progress) -->
    <button
      v-if="
        propertyStatus &&
        propertyStatus.activated_at &&
        (propertyStatus.type == 'for_rent' || propertyStatus.type == 'in_application')
      "
      type="button"
      class="has-text-centered button is-small is-white has-text-success"
      @click="confirmDeactivatePropertyForRentStatus(propertyStatus)"
    >
      <b-tooltip
        :label="$t('online_property')"
        type="is-success"
        position="is-top"
      >
        <i class="mdi mdi-checkbox-blank-circle mdi-16px" />
      </b-tooltip>
    </button>
    <button
      v-if="
        propertyStatus &&
        !propertyStatus.activated_at &&
        (propertyStatus.type == 'for_rent' || propertyStatus.type == 'in_application')
      "
      type="button"
      class="button is-small is-white has-text-centered has-text-danger"
      @click="confirmActivatePropertyForRentStatus(propertyStatus)"
    >
      <b-tooltip
        :label="$t('off_line_property')"
        type="is-danger"
        position="is-top"
      >
        <i class="mdi mdi-checkbox-blank-circle mdi-16px" />
      </b-tooltip>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    propertyStatus: {
      default: null,
      type: Object,
    },
  },
  methods: {
    confirmActivatePropertyForRentStatus(propertyStatus) {
      var canUpdate = this.$roleCan([
        this.$laravel.role_admin,
        this.$laravel.role_employee,
      ]);

      if (canUpdate) {
        this.$buefy.dialog.confirm({
          title: this.$t("activate_for_rent_status_title"),
          message: "",
          confirmText: this.$t("save"),
          cancelText: this.$t("cancel"),
          type: "is-success",
          hasIcon: false,
          onConfirm: () => this.activatePropertyForRentStatus(propertyStatus),
        });
      }
    },
    // Green dot: confirm, then take the ad offline (red dot)
    confirmDeactivatePropertyForRentStatus(propertyStatus) {
      const canUpdate = this.$roleCan([
        this.$laravel.role_admin,
        this.$laravel.role_employee,
      ]);

      if (!canUpdate) {
        return;
      }

      this.$buefy.dialog.confirm({
        title: this.$t("deactivate_for_rent_status_title"),
        message: "",
        confirmText: this.$t("save"),
        cancelText: this.$t("cancel"),
        type: "is-danger",
        hasIcon: false,
        onConfirm: () => {
          this.$http
            .patch(
              this.$laravel.route(
                "api.property.statuses.deactivate_for_rent_status",
                {
                  property: propertyStatus.property_id,
                  propertyStatus: propertyStatus.id,
                }
              )
            )
            .then((response) => {
              this.$emit("success", response.data);
            })
            .catch((e) => {
              console.error(e);
            });
        },
      });
    },
    activatePropertyForRentStatus(propertyStatus) {
      this.$http
        .patch(
          this.$laravel.route(
            "api.property.statuses.activate_for_rent_status",
            {
              property: propertyStatus.property_id,
              propertyStatus: propertyStatus.id,
            }
          )
        )
        .then((response) => {
          this.$emit("success", response.data);
        })
        .catch((e) => {
          console.error(e);
          this.$router.push("/properties");
        });
    },
  },
};
</script>

<style></style>
